import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SupervisionError, SubIssue, SupervisionErrorStatusEnum } from 'solar-bo';
import { MapSupervisionHelper } from '@solar/ol';
import { GlobalService } from '@solar/services/global.service';
import { ControlEnum } from 'solar-bo';
import { fabric } from 'fabric';
import { CanvasFilter } from '@solar/shared/canvasfilter.model';
import { CanvasIssueConfig } from '@solar/solar/models/canvasissueconfig.model';
import { IssueTypeHelper } from '@solar/solar/models/IssueTypeHelper.model';
import { dateInputsHaveChanged } from '@angular/material/datepicker/datepicker-input-base';


@Component({
  selector: 'app-issuecanvas',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './issuecanvas.component.html',
  styleUrls: ['./issuecanvas.component.scss']
})
export class IssuecanvasComponent implements OnInit, AfterViewInit, OnDestroy {


  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  /** canvas id   */
  @Input() canvas_id: string = "canvas_" + Math.floor(Math.random() * 10000);
  fabcanvas: fabric.Canvas;
  canvasFilter: CanvasFilter;
  /**
   * Panel Marker is the top arrow for the panel
   */
  panelMarker: any[] = [];

  private _issue: SupervisionError;
  /**
   * Actual issue if exist
   */
  @Input() set issue(value: SupervisionError) {
    console.log("set issue START");
    this.configureViewByIssue(value);
    console.log("set issue end");
  }
  get issue() {
    return this._issue;
  }
  @Input() supervision;

  private _bgimage_url;
  @Input() public get bgimage() {
    return this._bgimage_url;
  }
  public set bgimage(value) {
    let encodedValue=encodeURI(value);
    if (encodedValue == this._bgimage_url) {
      return;
    }
    console.log("set bgimage START");
    this._bgimage_url =encodedValue;
    this.loadBackground();
    console.log("set bgimage end");
  }
  /**
   * List fo issues that component can draw on image
   */
  @Input() issueList: SupervisionError[];
  /**
   * Image id of the issue or background image
   * Nuevo No usado todavia
   */
  @Input() imageId: number = -1;
  @Input() width: number = 320;
  @Input() height: number = 256;
  @Input() showIssueOnCanvas: boolean = false;
  @Input() editIssueOnCanvas: boolean = false;

  private _zoom: number = 1;
  @Input() public get zoom(): number {
    return this._zoom;
  }
  public set zoom(value: number) {
    this._zoom = value;
    if (this.fabcanvas) {
      this.fabcanvas.setZoom(value);
    }
  }
  @Input() canvas_options = { panelStrokeWidth: 2, markerStrokeColor: "rgb(0,0,0)", markerSize: 15, useIssueColor: false, useDefault: false, zoom: 1 };
  outsideWrapper_style = "width:320px;height:256px;";
  /**
   * background image object. Used for filters
   */
  public backGroundImgObject: any;
  scaleX = 1;
  scaleY = 1;


  @Output() onRightClick = new EventEmitter();
  /**
   * event raised when the background is loaded. 
   */
  @Output() onBackGroundLoaded = new EventEmitter();

  /**
   * scale type used to show the background image. 
   * S=standar, in this case features are drawed using the scale. Recommended.
   * Z=Zoom, in this case all features are drawed with the scale of the zoom so features visibility can be small
   */
  private scaleType="S";


  constructor(
    private elementRef: ElementRef
    , public globService: GlobalService) {
    this.showIssueOnCanvas = globService.checkAuthorizationById(ControlEnum.SUPERVISION_SHOWISSUEONCANVAS);
    this.canvasFilter = new CanvasFilter(this);
  }

  ngOnInit() {
    this.outsideWrapper_style = "width:" + this.width + "px;height:" + this.height + "px;";
  }


  ngAfterViewInit() {
    console.log("ngAfterViewInit START");
    this.configureFabric();
    if (this._issue) {
      this.loadIssue();
    }
    else if (this._bgimage_url) {
      this.loadBackground();
    }

    console.log("ngAfterViewInit END");
  }



  ngOnDestroy() {
    let ref = this.elementRef.nativeElement.querySelector('.upper-canvas');
    if (ref) {
      ref.removeEventListener('contextmenu', this.handleRightClick.bind(this));
    }
  }

  configureFabric() {
    //remove actual listeners
    let ref = this.elementRef.nativeElement.querySelector('.upper-canvas');
    if (ref) {
      ref.removeEventListener('contextmenu', this.handleRightClick.bind(this));
    }

    if (this.editIssueOnCanvas) {
      this.fabcanvas = new fabric.Canvas(this.canvas.nativeElement.id, { selection: true, fireRightClick: true });
      this.fabcanvas.hoverCursor = "default";
    }
    else {
      this.fabcanvas = new fabric.Canvas(this.canvas.nativeElement.id, { selection: true, fireRightClick: true });
      this.fabcanvas.hoverCursor = "default";
    }

    this.fabcanvas.uniScaleTransform = true;
    this.fabcanvas.setZoom(this.zoom);
    //this.fabcanvas.renderOnAddRemove=true;

    this.elementRef.nativeElement.querySelector('.upper-canvas')
      .addEventListener('contextmenu', this.handleRightClick.bind(this));

    this.fabcanvas.on('mouse:up', (event) => {
      if (event.button === 1) {
        //console.log("left click");
      }
      if (event.button === 2) {
        //console.log("middle click");
      }
      if (event.button === 3) {
        event.e.stopPropagation();
        event.e.preventDefault();
        //this.handleRightClick(event.e);
        //event.e.preventDefault();
      }
    });
  }

  

  /**
   * loadbackground when no issue exists. Based on image URL
   * @returns 
   */
  loadBackground() {
    console.log("loadBackground START ", this._bgimage_url);    
    if (!this.fabcanvas) {
      return;
    }
    //remove actual background
    if (this.backGroundImgObject) {
      this.fabcanvas.remove(this.backGroundImgObject);
    }
    if (!this._bgimage_url) {
      return;
    }

    let context:IssuecanvasComponent = this;

    fabric.Image.fromURL(this._bgimage_url, function (oImg) {
      let str = oImg.getSrc();
      let isInString = str.includes(context._bgimage_url);

      if (!isInString) {
        console.log("IMAGE IS DIFF: ", context._bgimage_url, oImg.getSrc());
        return;
      }
      context.configImageBackground(context,oImg);
      context.onBackGroundLoaded.emit(oImg);

    }, { crossOrigin: 'anonymous' }

    );
  }

  /**
   * loadbackground when no issue exists. Based on image URL
   * @returns 
   */
   reloadLoadBackground() {
    console.log("loadBackground START ", this._bgimage_url);    
    if (!this.fabcanvas) {
      return;
    }
    //remove actual background
    if (this.backGroundImgObject) {
      this.fabcanvas.remove(this.backGroundImgObject);
    }
    if (!this._bgimage_url) {
      return;
    }

    let context:IssuecanvasComponent = this;
    let src=this._bgimage_url + "?timestamp=" + new Date().getTime();
    fabric.Image.fromURL(src, function (oImg) {
      let str = oImg.getSrc();
      context.configImageBackground(context,oImg);
    }, { crossOrigin: 'anonymous' }

    );
  }

  /**
   * load background and after the download is complete draw the features like panels
   * @returns 
   */
  loadIssue() {
    console.log("loadIssue START ", this._issue);
    
    if (!this.fabcanvas || !this._issue) {
      return;
    }
    //remove actuall background
    if (this.backGroundImgObject) {
      this.fabcanvas.remove(this.backGroundImgObject);
    }

    this._bgimage_url = MapSupervisionHelper.issueUrlImg(this._issue, this._issue.supervision.site.id, this._issue.supervision.id);
    this._bgimage_url=encodeURI(this._bgimage_url);
    console.log("loadIssue bgimage is ", this._bgimage_url);

    let context:IssuecanvasComponent = this;
    fabric.Image.fromURL(this._bgimage_url, function (oImg) {
      //oImg.scale(0.5).set('flipX', true);
      //console.log("Canvas IMAGE IS:", oImg.getSrc());
      let str = oImg.getSrc();
      let isInString = str.includes(context._bgimage_url);

      if (!isInString) {
        console.log("IMAGE IS DIFF: ", context._bgimage_url, oImg.getSrc());
        return;
      }
     
      context.configImageBackground(context,oImg);
      context.drawFeatures();
      context.onBackGroundLoaded.emit(oImg);
      console.log("loadIssue END");

    }, { crossOrigin: 'anonymous' }

    );
    
  }
  /**
   * configure the image background
   * @param context 
   * @param oImg 
   */
  private configImageBackground(context:IssuecanvasComponent,oImg:fabric.Image){
    oImg.selectable = false;
    oImg.hasControls = false;
    oImg.set('data', { type: "BACKGROUND" });
    
    context.configCanvasScaleType(context,oImg);    
    context.backGroundImgObject = oImg;
    context.fabcanvas.add(oImg);
    oImg.moveTo(0);
    context.canvasFilter.applySelectedFiltersToImageBackground();
    
    context.scaleX = oImg.scaleX;
    context.scaleY = oImg.scaleY;
    console.log("Canvas zoom " + context.fabcanvas.getZoom() + " scaleX:" + context.scaleX);
  }
  /**
   * Configure the class style
   * @param context 
   * @param oImg 
   */
  private configCanvasScaleType(context:IssuecanvasComponent,oImg:fabric.Image){
    if (context.scaleType=="Z"){
      let zoom = context.width / oImg.width;
      context.zoom = zoom;
      context.fabcanvas.setZoom(zoom);
    }
    else {
      oImg.scaleToWidth(context.width/context.zoom);
      //oImg.scaleToHeight(cls.height);//no es necesario y descuadraria la proporcion si el contenedor no tiene la misma proporcion que la imagen
    }
  }

  drawFeatures() {
    if (this._issue) {
      console.log("drawFeatures START");
      this.drawIssuesByImage(this._issue.image.id);
      this.draw_issue_panel_on_image(this._issue, true);
      this.draw_subissues(this._issue);
      this.fabcanvas.requestRenderAll();
      console.log("drawFeatures END");
    }
  }

  /**
   * Find all issues in this image and draw all
   * @param id_image 
   */
  drawIssuesByImage(id_image: string) {
    //console.log("findIssuesByImage" + id_image);

    if (!this.issueList) {
      return;
    }
    let lst = this.issueList.filter(item => item.image.id == id_image);
    if (lst.length == 0) {
      return;
    }
    for (let issue of lst) {
      this.draw_issue_panel_on_image(issue);
    }
  }

  configureViewByIssue(newIssue: SupervisionError) {
    console.log("IssuecanvasComponent configureIssue ", newIssue);
    if (!newIssue) {
      this._issue = null;
      return;
    }
    let isNew: boolean = false;
    let prevIssue: SupervisionError = this._issue;

    if (!prevIssue) {
      isNew = true;
    } else if (prevIssue.id != newIssue.id) {
      isNew = true;
    }

    if (isNew == false) {
      return;
    }

    //remove marker
    if (this.panelMarker) {
      for (let obj of this.panelMarker) {
        this.fabcanvas.remove(obj);
      }

      this.panelMarker = [];
    }

    if (prevIssue) {
      //this.removeAllObjects();no usar
      //this.removeIssuePanels();
      this.clearObjectByDataId(prevIssue.id);
      //this.removeObjectByDataId(prevIssue.id);
      this._issue = newIssue;
      //this.loadIssue();

      if (prevIssue.image.id != newIssue.image.id) {        
        console.log("DIFERENT IMAGE");
        this.removeIssuePanels();
        this.loadIssue();
        return;
        //draw new objets
        this.drawIssuesByImage(newIssue.image.id);
      }
      else {
        console.log("SAME IMAGE");
      }
    }

    let existObj: any = this.findObjectByDataId(newIssue.id);
    if (!existObj) {
      //this.removeAllObjects();
      //this.removeIssuePanels();
      this.draw_issue_panel_on_image(newIssue, true);
      this.draw_subissues(newIssue);
      //this.fabcanvas.requestRenderAll();
    }
    else {
      let sel: fabric.Polygon = existObj;
      sel.strokeWidth = 2;
      sel.set('dirty', true);
      let strokeColor = "rgb(0,10,0)";//black??
      this.drawPanelMarker(sel.left, sel.top, strokeColor);
      this.fabcanvas.requestRenderAll();
    }

    this._issue = newIssue;
  }

  resetFabCanvas() {
    //remove actual listeners    
    let ref = this.elementRef.nativeElement.querySelector('.upper-canvas');
    if (ref) {
      ref.removeEventListener('contextmenu', this.handleRightClick.bind(this));
    }
    if (this.fabcanvas) {
      this.fabcanvas.dispose();
      //let obj:any=this.fabcanvas.getObjects();
      //this.fabcanvas.remove(obj);      
    }

    this.fabcanvas = null;
    this.configureFabric();
  }

  add(item) {
    if (!this.editIssueOnCanvas) {
      return;
    }
    this.fabcanvas.add(item);
  }
  addPath() {
    let path = new fabric.Path('M 0 0 L 200 100 L 170 200 z');
    path.set({ left: 120, top: 120 });
    this.fabcanvas.add(path);
  }

  resetCanvas() {
    try {
      this.resetFabCanvas();
    }
    catch (err) {
      console.log(err);
    }
  }

  uiurlimg(issue: SupervisionError): string {
    return MapSupervisionHelper.issueUrlImgByIssue(issue);
  }

  /**
   * Draw the panel or bounds registered by issue
   * @param issue 
   * @param selected 
   */
  draw_issue_panel_on_image(issue: SupervisionError, selected = false) {
    console.log("draw_issue_panel_on_image");
    let polygons: any[] = [];
    try {
      if (!issue) {
        return;
      }

      let polyclone = null;

      if (issue.info != null && issue.info.geometry_panel && issue.info.geometry_panel.coordinates) {
        polyclone = issue.info.geometry_panel.coordinates;
      }
      if (!polyclone) {
        return;
      }

      let poly = JSON.parse(JSON.stringify(polyclone[0]));

      let points: any[] = this.convertGeomToPoints(poly);

      let strokeColor = "rgb(0,0,0)";
      if (this.canvas_options.useIssueColor == true) {
        strokeColor = IssueTypeHelper.issueGetErrorTypeColor(issue.type);

      } else if (this.canvas_options.useDefault == true) {
        strokeColor = "rgb(0,10,0)";
      } else {
        if (this._issue.info.status == SupervisionErrorStatusEnum.validated) {
          strokeColor = "green";
        }
        else {
          strokeColor = "rgb(0,0,0)";
        }
      }

      let strokeWidth = this.canvas_options.panelStrokeWidth;
      if (selected == false) {
        strokeWidth = 1;
      }
      else {
        let markerStrokeColor = this.canvas_options.markerStrokeColor;
        if (this.canvas_options.useIssueColor == true) {
          markerStrokeColor = strokeColor;
        }

        this.drawPanelMarker(points[0].x, points[0].y, markerStrokeColor, this.canvas_options.markerSize);
        polygons.push(this.panelMarker);

      }
      let panel_polygon = new fabric.Polygon(points, {
        opacity: 1
        , strokeWidth: strokeWidth
        , stroke: strokeColor
        , fill: 'rgba(0,0,0,0)'
        , selectable: false
        , hasControls: false

      });
      panel_polygon.set('data', { id: issue.id, type: 'ISSUE_PANEL' });
      //polygon.set('selectable', false);
      // Render the polygon in canvas 
      this.fabcanvas.add(panel_polygon);
      polygons.push(panel_polygon);
      return polygons;


    } catch (error) {

    }
  }

  private convertGeomToPoints(poly){
    let points: any[] = [];
    for (let i = 0; i < poly.length - 1; ++i) {
      let x = +poly[i][0];
      let y = +poly[i][1];
      x = x * this.scaleX;
      y = y * this.scaleY;
      points.push({ x: x, y: y });
    }
    return points;
  }

  drawPanelMarker(x, y, strokeColor, size: number = 18) {
    let swidth = size * this.scaleX;
    let sheight = size * this.scaleY;

    let obj1 = new fabric.Triangle({ top: y, left: x, width: swidth, height: -sheight, fill: "rgb(0,0,0)" });
    obj1.set('data', { type: 'ISSUE_PANEL_MARKER' });
    this.fabcanvas.add(obj1);
    //border
    let fillColor=strokeColor ;//"rgb(255,255,255)";//strokeColor

    let obj = new fabric.Triangle({ top: y - 3, left: x + 3, width: (swidth - 6), height: -(sheight - 6), fill: fillColor });
    obj.set('data', { type: 'ISSUE_PANEL_MARKER' });
    this.fabcanvas.add(obj);
    this.panelMarker.push(obj1);
    this.panelMarker.push(obj);
    return obj
  }

  private findObjectByDataId(id: string) {
    if (!this.fabcanvas) {
      return null;
    }
    for (let obj of this.fabcanvas.getObjects()) {
      if (obj.data && obj.data.id === id) {
        return obj;
      }
    }
    return null;
  }
  /**
   * Remove issue panels from canvas.
   */
  removeIssuePanels() {
    let canvas = this.fabcanvas;
    if (canvas == null) {
      return;
    }
    let removedItems = 0;
    for (let obj of canvas.getObjects()) {

      if (obj.data && obj.data.type) {
        switch (obj.data.type) {
          case 'ISSUE_PANEL':
          case 'ISSUE_PANEL_MARKER':
            canvas.remove(obj);
            removedItems += 1;
        }
      }
    }
    if (removedItems > 0) {
      canvas.requestRenderAll();
    }
  }

  /**
  * Remove all objects from canvas.
  */
  removeAllObjects() {
    let canvas = this.fabcanvas;
    if (canvas == null) {
      return;
    }
    let removedItems = 0;
    for (let obj of canvas.getObjects()) {
      canvas.remove(obj);
      removedItems += 1;


    }
    if (removedItems > 0) {
      //canvas.requestRenderAll();
      canvas.renderAll();
    }
  }

  private removeObjectByDataId(id: string) {
    let canvas = this.fabcanvas;
    if (canvas == null) {
      return;
    }
    for (let obj of this.fabcanvas.getObjects()) {
      if (obj.data) {
        if (obj.data.id === id) {
          canvas.remove(obj);
          canvas.renderAll();
          break;
        }
      }
    }
  }  

  private clearObjectByDataId(id: string) {
    let selected: any;
    for (let obj of this.fabcanvas.getObjects()) {
      if (obj.data) {
        if (obj.data.id === id) {
          selected = obj;
          break;
        }
        else {
          //obj.set("strokeWidth:1");
        }
      }
    }
    if (selected) {
      let sel: fabric.Polygon = selected;
      sel.strokeWidth = 1;
      sel.set('dirty', true);
    }
    return null;
  }

  draw_subissues(issue: SupervisionError) {
    if (!this.showIssueOnCanvas) {
      return;
    }
    if (!this.fabcanvas) {
      return null;
    }

    if (!issue.info.errors) {
      return;
    }
    for (let subi of issue.info.errors) {
      this.draw_subissue_on_image(subi);
    }
  }

  /**
   * draw other issue on image with diferent styles
   * @param subissue 
   */
  draw_subissue_on_image(subissue: SubIssue) {
    try {
      if (!subissue) {
        return;
      }
      let polyclone = null;
      if (subissue != null && subissue.geometry && subissue.geometry.coordinates) {
        polyclone = subissue.geometry.coordinates;
        if (!polyclone) {
          return;
        }
      }
      else {
        return;
      }


      let poly = JSON.parse(JSON.stringify(polyclone[0]));
      let points: any[] = this.convertGeomToPoints(poly);

      let strokeColor = "rgb(0,0,0)";
      let polygon = new fabric.Polygon(points, {
        opacity: 0.9
        , strokeWidth: 0.5
        , stroke: strokeColor
        , fill: 'rgba(0,0,0,0)'
        , selectable: false
        , hasControls: false
      });

      this.fabcanvas.add(polygon);
      return polygon;



    } catch (error) {
      console.log(error);
    }
  }

  handleRightClick($event) {
    console.log($event);
    $event.stopPropagation();
    $event.preventDefault();
    this.onRightClick.emit({ event: $event, issue: this._issue });

  }
}
